import { render, staticRenderFns } from "./header-warp.vue?vue&type=template&id=dc6e5560&scoped=true&"
import script from "./header-warp.vue?vue&type=script&lang=js&"
export * from "./header-warp.vue?vue&type=script&lang=js&"
import style0 from "./header-warp.vue?vue&type=style&index=0&id=dc6e5560&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc6e5560",
  null
  
)

export default component.exports